import Api from "@/lib/axios";

const RecordService = {
  getList(params) {
    const data = {
      ...params,
      page: (params.page || 1) - 1
    };
    return Api.get("/api/autopricing/records", {
      data: data,
      tenant: true
    }).then(response => {
      let list = response?.data?.content || [];
      let pagination = response?.data?.pageable || {};
      return {
        list,
        pagination: {
          ...pagination,
          totalElements: response?.data?.totalElements,
          totalPages: response?.data?.totalPages
        }
      };
    });
  },
  create(params) {
    return Api.post("/api/autopricing/records", params, { tenant: true });
  },
  update(params) {
    return Api.patch("/api/autopricing/records", params, { tenant: true });
  },
  delete(params) {
    return Api.delete("/api/autopricing/records", { params, tenant: true });
  },
  uploadCsv(params) {
    return Api.post("/api/autopricing/records/bulk-upload-csv", params, {
      tenant: true
    });
  },
  previewCsv(params) {
    return Api.post(
      "/api/autopricing/records/bulk-upload-csv-preview",
      params,
      {
        tenant: true
      }
    ).then(res => {
      return res?.data?.previewRecords || [];
    });
  },
  downloadCsv(params) {
    return Api.get("/api/autopricing/records/download-csv", {
      data: params,
      tenant: true
    });
  },
  clearManualRates(params) {
    return Api.post("/api/autopricing/records/clear-manual-rate", params, {
      tenant: true
    });
  },
  getCornerCases() {
    return Api.get("/api/autopricing/records/corner_cases", {
      tenant: true
    });
  },
  getTenants() {
    return Api.get("/api/autopricing/onload/tenants")
  }
};

export default RecordService;
